// extracted by mini-css-extract-plugin
export default {"field":"PreconfiguredFramesField__field--eNAaY","label":"PreconfiguredFramesField__label--zWq8d"};